import React, {useState} from 'react';
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {useTecRmiComponentTopics} from "../../../contexts/TecRmiComponentTopicsContext";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import appUserRoutes from "../../../appUserRoutes";
import {ButtonGroup} from "reactstrap";
import {getByModuleId} from "../Modules";
import Link from "../../Application/Link";
import classnames from "classnames";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";

const ComponentSubGroup = props => {
  const { ident, showType } = useTecRmi()
  const componentTopics = useTecRmiComponentTopics()
  const mainGroupId = parseInt(props.match.params.mainGroupId)
  const subgroupId = parseInt(props.match.params.subgroupId)
  const componentTopic = componentTopics.find(componentTopic => componentTopic.MaingroupId === mainGroupId)
  const subGroup = componentTopics.find(componentTopic => componentTopic.MaingroupId === mainGroupId).Subgroups.find(subGroup => subGroup.SubgroupId === subgroupId)
  const [moduleActive, setModuleActive] = useState(props.match.params.module ? parseInt(props.match.params.module) : subGroup.AvailableModules[0])

  useAfterUpdateEffect(() => {
    if(parseInt(props.match.params.module) !== moduleActive){
      setModuleActive(parseInt(props.match.params.module))
    }
  }, [props.match.params.module])

  const renderModuleComponent = (moduleActive) => {
    const module = getByModuleId(moduleActive)

    return <React.Fragment>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tabComponentSubGroup(ident, mainGroupId, subgroupId, subGroup.AvailableModules[0], '')}>{subGroup.SubgroupText}</BreadcrumbsItem>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tabComponentSubGroup(ident, mainGroupId, subgroupId, moduleActive, '/')}>{module.name}</BreadcrumbsItem>

      <module.component
        componentSubgroupId={subGroup.SubgroupId}
        pathPrefix={appUserRoutes.tecRmi.tabComponentSubGroup(ident, mainGroupId, subgroupId, moduleActive, '') + '/'}
        params={props.match.params.params ? props.match.params.params.split('/') : []}
        pathHome={appUserRoutes.tecRmi.tabComponentMainGroup(ident, mainGroupId)}
      />
    </React.Fragment>
  }

  return (
    <div>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tabComponentMainGroup(ident, componentTopic.MaingroupId)}>{componentTopic.MaingroupText}</BreadcrumbsItem>

      <ButtonGroup>
        {subGroup.AvailableModules.map(moduleId => {
          const module = getByModuleId(moduleId)

          if(!module){
            return null
          }

          return <Link
            to={appUserRoutes.tecRmi.tabComponentSubGroup(ident, mainGroupId, subgroupId, moduleId, '')}
            className={classnames({
              'btn': true,
              'btn-primary': moduleActive === moduleId,
              'btn-light': moduleActive !== moduleId,
            })}
          >{module.name}</Link>
        })}
      </ButtonGroup>

      {moduleActive && renderModuleComponent(moduleActive)}
    </div>
  );
};

ComponentSubGroup.propTypes = {

};

export default ComponentSubGroup;